"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: theme.spacing(2)
    },
    center: {
        display: 'flex',
        alignItems: 'center'
    },
    detailCardWrapper: {
        paddingBottom: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            paddingBottom: theme.spacing(4),
            paddingRight: 0
        }
    },
    button: {
        marginTop: theme.spacing(),
        minWidth: 295,
        padding: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            minWidth: '100%'
        }
    },
    buttonLabelIcon: {
        fontSize: 16
    },
    details: {
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column'
        }
    },
    spacing: {
        marginBottom: theme.spacing(2)
    },
    largeIcon: {
        fontSize: '2.5rem'
    },
    videoUrlClass: {
        display: 'flex',
        alignItems: 'center',
        zIndex: 1000,
        height: '300px',
        [theme.breakpoints.down('xs')]: {
            height: '240px'
        }
    }
});
exports.default = styles;
//# sourceMappingURL=EarnActivityHeaderStyle.js.map